import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import velocitySmaller from "./components/velocity-smaller";
import velocityEqual from "./components/velocity-equal";
import velocityLarger from "./components/velocity-larger";

const principle: Slide = {
  description:
    "The difference between phase and group velocities is illustrated for phase velocity smaller than, equal to, and larger than group velocity. It is then proposed to see how a burst centred at 68 Hz is changed due to the dispersion, either of the Klein Gordon type (at 2 propagation distances and 3 cut-off frequencies fc) or in a tube of 2 mm-radius with visco-thermal losses for several propagation distances. Due to the dispersion, different frequency components of the burst propagate at different velocity, hence dispersing the burst profile.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Phase and group velocities",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "button",
                    options: {},
                    items: [
                      { name: "Phase velocity smaller than group velocity" },
                      { name: "Phase velocity equal to group velocity" },
                      { name: "Phase velocity larger than group velocity" },
                    ],
                  },
                ],
                controlsPosition: "bottom",
                extraContent: [[], [], []],
                components: [velocitySmaller, velocityEqual, velocityLarger],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
